/* globals document, window */
import React from "react";
import { hydrate } from "react-dom";
import PrivacyPolicy from "./PrivacyPolicy";

/* Render Privacy Policy app into the pug template */
function render(props) {
  hydrate(<PrivacyPolicy {...props} />, document.getElementById("react"));
}

render(window.reactProps);
